import React from 'react';
import {
  FDTitleText,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import ManagedAccountModelUpdateRequestNotesPicker
  from 'Views/Page/Content/Modal/Layouts/ManagedAccountModelUpdateRequestDialog/Layout/ManagedAccountModelUpdateRequestNotesPicker/ManagedAccountModelUpdateRequestNotesPicker';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dispatchModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import { localStorageMap } from 'Consts/localStorage';
import ResizableBox from 'Components/ComponentLibrary/Atoms/ResizableBox';
import ManagedAccountModelUpdateRequestLayout from './ManagedAccountModelUpdateRequestLayout';
import ManagedAccountModelUpdateRequestOverride from './MetaOverrideSet';


const useStyles = buildUseStyles('ManagedAccountChangeRequestDialog', ((theme) => ({
  content: {
    display: 'flex',
    gap: `${theme.spacing(2)}px`,
    maxHeight: theme.dimensions.xl,
    height: '100%',
  },
  contentLeftSide: {
    flexGrow: 1,
  },
  contentRightSide: {
    paddingLeft: theme.spacing(2),
    flexShrink: 0,
    flexGrow: 0,
    width: '100%',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  leftSideForms: {
    height: '100%',
  },
  leftSideForm: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
  },
  scrollable: {
    padding: theme.spacing(0, 2),
    overflowY: 'auto',
    flexGrow: 1,
  },
})));

function Layout() {
  const {
    modalCollection,
    clearModalCollection,
  } = useModalContext();
  const { displaySuccess, displayErrorMessage } = useSnackbarContext();
  const classes = useStyles();
  const notesPortalRef = React.useRef();
  const resource = modalCollection.resources().head();
  const theme = useTheme();

  return (
    <>
      <div className={classes.content}>
        <MetaCollectionFormInline
          margin={'none'}
          padding={'none'}
          classes={{
            root: classes.contentLeftSide,
            forms: classes.leftSideForms,
            form: classes.leftSideForm,
          }}
          collection={modalCollection}
          metaOverrideSet={ManagedAccountModelUpdateRequestOverride}
          FormProps={{
            onFailure: (err) => {
              displayErrorMessage(err, err.errors);
            },
            padding: 'none',
            margin: 'none',
            layout: ManagedAccountModelUpdateRequestLayout,
            LayoutProps: {
              onlyRenderLayout: true,
              hideErrorList: true,
            },
            noIndividualSubmitButtons: true,
            onSubmit: () => {
              dispatchModalContextSubmissionSuccessful();
              clearModalCollection();
              displaySuccess('Saved updates');
            },
          }}
        />
        <ResizableBox
          className={classes.contentRightSide}
          side={'left'}
          localStorageName={localStorageMap.updateRequestNotes}
          minSize={theme.dimensions.sm}
        >
          <FDTitleText size={'lg'} value={'Notes'} />
          <div className={classes.scrollable}>
            <ManagedAccountModelUpdateRequestNotesPicker
              notesPortalRef={notesPortalRef}
              managedAccountModelUpdateRequestResource={resource}
            />
          </div>
          <div ref={notesPortalRef} />
        </ResizableBox>
      </div>
    </>
  );
}

Layout.defaultProps = {
};

Layout.propTypes = {
};

export default Layout;
